<template>
    <div
        v-if="loggedIn"
        class="mb15 md-layout-item md-xlarge-size-100 md-layout-item md-large-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100 text-left"
    >
        <div class="carrier-content">
            <div class="flex-center">
                <md-avatar class="mr15">
                    <img
                        :src="require('@assets/images/default_avatar.png')"
                        alt="Avatar"
                    />
                </md-avatar>

                <div class="flex-column">
                    <div class="phone-number">
                        {{ formatPhoneNumber(currentPassenger.phonenumber) }}
                    </div>

                    <md-button
                        v-if="!currentPassenger.verifyPhoneNumber"
                        class="buy-medal"
                        @click="
                            () => {
                                showModal = true;
                            }
                        "
                        >{{ $t('components.confirmTheNumber') }}</md-button
                    >
                </div>
            </div>
            <div
                v-if="!disabledRightArea && countCarriers"
                class="content-right"
            >
                <div class="flex-column">
                    <h2 class="h2 waiting-room">
                        {{ $t('components.selectedCarriers') }}
                    </h2>
                    <div class="dib right c13184f">
                        {{ $t('waitingRoom.carriers') }}: {{ countCarriers }}
                    </div>
                </div>
            </div>
        </div>
        <confirm-phone-modal
            :show="showModal"
            @close="() => (showModal = false)"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import config from '@config';
import parsePhoneNumber from 'libphonenumber-js';
import ConfirmPhoneModal from '../modals/confirmPhoneModal';

export default {
    props: {
        disabledRightArea: {
            type: Boolean,
            default: false
        }
    },

    components: {
        ConfirmPhoneModal
    },

    data() {
        return {
            showModal: false
        };
    },

    computed: {
        ...mapGetters({
            currentPassenger: 'auth/currentPassenger',
            loggedIn: 'auth/loggedInAsPassenger',
            countCarriers: 'passengerContent/countCarriers'
        }),

        baseUrl() {
            return config.mediaBaseUrl;
        }
    },

    methods: {
        formatPhoneNumber(phoneNumberString) {
            const phoneNumber = parsePhoneNumber(phoneNumberString);
            return phoneNumber.formatInternational();
        }
    },

    mounted() {}
};
</script>

<style scoped>
@media only screen and (max-width: 550px) {
    .content-right {
        display: none;
    }
}
.flex-column {
    display: flex;
    flex-direction: column;
}

.md-avatar {
    top: 0 !important;
}

.flex-center {
    display: flex;
    align-items: center;
}

.carrier-content {
    padding-top: 10px;
}

.phone-number {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: rgba(0, 0, 0, 0.87);
}
</style>
